/* eslint-disable no-use-before-define */
import React, { useEffect, useRef, useState } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import Styles from '../lib/Styles';
import APIService from '../shared/api-service';
import IMake from '../shared/IMake';
import IModel from '../shared/IModel';
import classes from './SelectField.module.scss';

// Class variables used to help determine when the selected makes is changed.
let previousMakes: Array<IMake> | undefined = undefined;
let previousModels: Array<IModel> | undefined = undefined;

export default function SelectYears(props: any) {

  const { selectedYears, setSelectedYears, onChangeYears, readOnly } = props;
  const selectedMakes: Array<IMake> = props.selectedMakes;
  const selectedModels: Array<IModel> = props.selectedModels;
  const [makeOrModelChanged, setMakeOrModelChanged] = useState<boolean>(true);
  let initialValue = useRef(props.initialValue);
  const cx = new Styles(classes).cx;

  const [loaded, setLoaded] = useState<boolean>(false);
  // The list of years retrieved from the server
  const [years, setYears] = useState<Array<number>>([]);

  useEffect(() => {
    if (loaded && initialValue.current && years && years.length > 0) {
      let yrs: Array<number> = initialValue.current.split(',').map((item: string) => parseInt(item.trim()));
      let selectedYrs: Array<number> = new Array<number>();
      for (let i = 0; i < yrs.length; i++) {
        let yr: number = yrs[i];
        const index = years.findIndex((item: number) => item === yr);
        if (index >= 0) {
          selectedYrs.push(years[index]);
        }
      }
      setSelectedYears(selectedYrs);
      initialValue.current = undefined;
    }
  }, [loaded, years, setSelectedYears]);

  useEffect(() => {
  // When the selectedMakes or models is/are changed, clear the years and invoke onChangeSelectedYears() callback.
  if ((previousMakes !== selectedMakes) || (previousModels !== selectedModels)) {
    previousMakes = selectedMakes;
    previousModels = selectedModels;
    setMakeOrModelChanged(true);
    setYears([]);
    onChangeSelectedYears(null, []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMakes, selectedModels])

  useEffect(() => {
  // If user has selected or modified a makes/model then fetch the year data for the selectedMakes/models.
  if (makeOrModelChanged && selectedMakes) {
    setMakeOrModelChanged(false);
    const apiService = new APIService();
    const makeIds: string[] = selectedMakes.map((make: IMake) => make.Id)
    const modelIds: string[] = selectedModels.map((model: IModel) => model.Id)
    setLoaded(false);
    apiService.retrieveYears(makeIds, modelIds).then((years: any[]) => {
        setYears(years ? years : []);
        setLoaded(true);
    })
  } else if (!selectedMakes) {
    if (!loaded) {
      setLoaded(true);
    }
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMakes, selectedModels, makeOrModelChanged])

  return (
    <div className={cx('root')}>
      <Autocomplete
        disabled={readOnly || (!years || years.length === 0)}
        multiple
        options={years}
        getOptionLabel={(option) => '' + option}
        defaultValue={undefined}
        value={selectedYears}
        filterSelectedOptions
        onChange={onChangeSelectedYears}

        renderInput={(params: any) => (
          <TextField
            {...params}
            variant="outlined"
            label={!loaded ? "Loading Years ..." : selectedMakes && selectedMakes.length > 0 && (years && years.length === 0) ? "There are no years on record." : "Years"}
            placeholder={"Select one or more years."}
            fullWidth
          />
        )}
      />
    </div>
  );

  function onChangeSelectedYears(event: any, values: any) {
    setSelectedYears(values);
    onChangeYears();
  }

}
